<template>
  <div>
    <vs-popup
        class="deliverer-modal"
        :title="getNameTitle"
        :active.sync="showPopup"
        v-if="deliverer !== null"
    >
      <vs-tabs>
        <vs-tab label="Gegevens" :active="true">
          <template>
            <div class="vx-row ">
              <div class="vx-col sm:w-1/3 w-full mb-2">
                <vs-input
                    class="w-full"
                    label="Naam"
                    :value="deliverer.firstname"
                    v-model="deliverer.firstname"
                />
              </div>
              <div class="vx-col sm:w-1/3 w-full mb-2">
                <vs-input
                    class="w-full"
                    label="Tussenvoegsel"
                    :value="deliverer.insertion"
                    v-model="deliverer.insertion"
                />
              </div>
              <div class="vx-col sm:w-1/3 w-full mb-2">
                <vs-input
                    class="w-full"
                    label="Achternaam"
                    v-if="deliverer.lastname"
                    :value="deliverer.lastname"
                    v-model="deliverer.lastname"
                />
              </div>
            </div>

            <div class="vx-row mb-6">
              <div class="vx-col w-1/2">
                <vs-input
                    class="w-full"
                    type="email"
                    label="E-mail"
                    :value="deliverer.email"
                    v-model="deliverer.email"
                />
              </div>
              <div class="vx-col w-1/2">
                <vs-input
                    class="w-full"
                    label="Telefoonnummer"
                    :value="deliverer.phone_number"
                    v-model="deliverer.phone_number"
                />
              </div>
            </div>
            <div class="vx-row">
              <div class="vx-col w-1/2">
                <vs-input
                    class="w-full"
                    type="text"
                    label="Postcode"
                    value="3211XM"
                    v-model="deliverer.address.postal_code"
                />
              </div>
              <div class="vx-col w-1/2">
                <vs-input
                    class="w-full"
                    label="Huisnummer"
                    value="118"
                    v-model="deliverer.address.housenumber"
                />
              </div>
            </div>
            <br>
            <div class="vx-row">
              <div class="vx-col w-full">
                <vs-input class="w-full" label="Address" disabled :value="address"/>
              </div>
            </div>
            <br>
            <div class="vx-row">
              <div class="vx-col w-full">
                <vs-input class="w-full" label="Salaris" v-model="deliverer.salary"/>
              </div>
            </div>
            <br>
            <div class="vx-row">
              <div class="vx-col w-1/2">
                <vs-select v-model="deliverer.area" id="deliverer-area" class="w-full" label="Regio">
                  <vs-select-item
                      v-for="(item) in areaOptions"
                      :key="item.name"
                      :value="item.name"
                      :text="item.name"
                  />
                </vs-select>
              </div>
              <div class="vx-col w-1/2">

                <vs-select v-model="deliverer.drivers_licence" class="w-full" label="Rijbewijs">
                  <vs-select-item
                      v-for="(item) in licenses"
                      :key="item.name"
                      :value="item.name"
                      :text="item.name"
                  />
                </vs-select>
              </div>
            </div>
            <br>

            <div class="vx-row mb-6">
              <div class="vx-col w-full">
                <ul class="switch-container">
                  <li>
                    <label>Kantoor</label>
                    <vs-switch v-model="deliverer.office"/>
                  </li>
                </ul>
              </div>
            </div>

            <vs-card>
              <div slot="header">
                <h5>Afbeelding</h5>
              </div>
              <div style="margin: 0 auto">
                <vs-upload @change="handleImageUpload" @on-delete="image = null"/>
              </div>
            </vs-card>


            <div class="vx-row">
              <div class="vx-col w-full" style="text-align: right;">
                <vs-button
                    class="mr-3 mb-2 vs-con-loading__container"
                    id="save-deliverer-button"
                    ref="loadableButton"
                    :disabled="loading"
                    v-if="!isDeleted"

                    @click="saveDelivererModal(deliverer)"
                    style="text-align: right"
                >Opslaan
                </vs-button>
                <vs-button
                    class="mr-3 mb-2"
                    @click="resetDeviceToken(deliverer)"
                    v-if="!isDeleted"
                    style="text-align: right"
                >Reset device token
                </vs-button>
                <vs-button
                    class="mr-3 mb-2"
                    @click="fireDeliverer(deliverer)"
                    v-if="!isDeleted"

                    style="text-align: right"
                >Verwijderen
                </vs-button>
                <vs-button
                    class="mr-3 mb-2"
                    @click="resetDeliverer(deliverer)"
                    v-if="isDeleted"

                    style="text-align: right"
                >Herstellen
                </vs-button>
              </div>
            </div>
          </template>
        </vs-tab>
        <vs-tab label="Notities" @click="getNotes">
          <vs-list>
            <vs-list-item v-for="note in notes" :title="note.note" subtitle :key="note.id"></vs-list-item>
            <vs-list-item v-if="notes === null" title="Notities laden..." subtitle></vs-list-item>
            <div v-if="notes !== null">
              <vs-list-item v-if="notes.length === 0" title="Geen notities gevonden"
                            subtitle></vs-list-item>
            </div>
          </vs-list>
        </vs-tab>
        <vs-tab label="Uren" @click="getHours">
          <vs-collapse>
            <vs-collapse-item v-for="(item, index) in hours" :key="index">
              <div slot="header">{{ getMonth(index) }}</div>
              <vs-list>
                <vs-list-item
                    v-for="hour in item"
                    class="va-list-item"
                    :title="$moment(hour.clocked_in_time).calendar()"
                    :subtitle="getTranslatedString(hour)"
                    :key="hour.id"
                    @click.native="editHour(hour)"
                >
                  <vs-button
                      color="danger"
                      type="flat"
                      icon-pack="feather"
                      icon="icon-trash-2 "
                      @click="deleteHour(hour)"
                  ></vs-button>
                </vs-list-item>
              </vs-list>
            </vs-collapse-item>
          </vs-collapse>
        </vs-tab>
        <vs-tab label="Kleding" @click="getClothes()">
          <vs-list>
            <vs-list-item v-for="clothe in clothes" :key="clothe.id" :title="clothe.value"
                          :subtitle="translateTime(clothe)">
              <vs-button
                  color="danger"
                  type="flat"
                  icon-pack="feather"
                  icon="icon-trash-2 "
                  @click="deleteClothing(clothe)"
              ></vs-button>
            </vs-list-item>

            <vs-list-item v-if="clothes === null" title="Kleding laden..." subtitle></vs-list-item>
            <div v-if="clothes !== null">
              <vs-list-item v-if="clothes.length === 0" title="Geen kleding uitgegeven"
                            subtitle></vs-list-item>
            </div>
          </vs-list>
          <vs-button class="mr-3 mb-2" @click="createClothing()">Kleding koppelen</vs-button>

        </vs-tab>
        <vs-tab label="Orders" @click="getJobs()">
          <vs-list>
            <vs-list-item v-for="delivery in orders" :key="delivery.id" :title="getOrderTitle(delivery)"
                          :subtitle="getAddressString(delivery, deliverer.area)"></vs-list-item>
            <div v-if="orders !== null">
              <vs-list-item :title="orders == null ? 'Een moment..' : (orders.length === 0 ? 'Geen gekoppelde bezorgingen gevonden' : '')"
                            subtitle></vs-list-item>
            </div>
          </vs-list>

        </vs-tab>
        <vs-tab label="SMS">
          <vs-list>
            <div class="vx-row">
              <div class="vx-col w-full mb-2">
              </div>
              <div class="vx-col sm:w-1/1 w-full mb-2">
                <vs-textarea
                    v-model="message"
                    rows="10"
                    cols="8"
                    placeholder="Schrijf hier jouw sms, maximaal 480 karakters!"
                    maxlength="480"
                />
              </div>
            </div>
            <vs-button class="smsbutton mr-3 w-full mb-2 vs-con-loading__container" id="send-sms-button"
                       ref="loadableButton"
                       @click="sendSms(deliverer)">Verstuur sms
            </vs-button>
          </vs-list>
        </vs-tab>
        <vs-tab label="Notificatie">
          <vs-list>
            <div class="vx-row">
              <div class="vx-col w-full mb-2">
                <vs-input
                    class="w-full"
                    placeholder="Schrijf hier jouw titel.."
                    v-model="title"
                />
              </div>
              <div class="vx-col sm:w-1/1 w-full mb-2">
                <vs-textarea
                    v-model="message"
                    rows="10"
                    cols="8"
                    placeholder="Schrijf hier jouw notificatie, maximaal 160 karakters!"
                    maxlength="160"
                />
              </div>
            </div>
            <vs-button class="smsbutton mr-3 w-full mb-2 vs-con-loading__container"
                       @click="sendNotification(deliverer)"
                       :disabled="canSendNotification"
                       id="send-deliverer-notification"
                       ref="loadableButton"
            >Verstuur notificatie
            </vs-button>
          </vs-list>
        </vs-tab>
      </vs-tabs>
    </vs-popup>
    <vs-popup
        class="deliverer-modal"
        :title="getCreateTitle"
        :active.sync="showCreatePopup"
        v-if="createDeliverer !== null"
    >
      <template>
        <div class="vx-row">
          <div class="vx-col sm:w-1/3 w-full mb-2">
            <vs-input
                class="w-full"
                label="Naam"
                :value="createDeliverer.firstname"
                v-model="createDeliverer.firstname"
            />
          </div>
          <div class="vx-col sm:w-1/3 w-full mb-2">
            <vs-input
                class="w-full"
                label="Tussenvoegsel"
                :value="createDeliverer.insertion"
                v-model="createDeliverer.insertion"
            />
          </div>
          <div class="vx-col sm:w-1/3 w-full mb-2">
            <vs-input
                class="w-full"
                label="Achternaam"
                :value="createDeliverer.lastname"
                v-model="createDeliverer.lastname"
            />
          </div>
        </div>
        <div class="vx-row mb-6">
          <div class="vx-col sm:w-1/2 w-full">
            <vs-input
                class="w-full"
                type="text"
                label="Postcode"
                value="3211XM"
                v-model="createDeliverer.address.postal_code"
            />
          </div>
          <div class="vx-col sm:w-1/2 w-full">
            <vs-input
                class="w-full"
                label="Huisnummer"
                value="118"
                v-model="createDeliverer.address.housenumber"
            />
          </div>
        </div>
        <div class="vx-row mb-6">
          <div class="vx-col w-full">
            <vs-input class="w-full" label="Address" disabled v-model="address"/>
          </div>
        </div>
        <div class="vx-row mb-6">
          <div class="vx-col sm:w-1/2 w-full">
            <vs-input
                class="w-full"
                type="email"
                label="E-mail"
                :value="createDeliverer.email"
                v-model="createDeliverer.email"
            />
          </div>
          <div class="vx-col sm:w-1/2 w-full">
            <vs-input
                class="w-full"
                label="Telefoonnummer"
                :value="createDeliverer.phone_number"
                v-model="createDeliverer.phone_number"
            />
          </div>
        </div>
        <div class="vx-row mb-6">
          <div class="vx-col sm:w-1/2 w-full">
            <template>
              <label for="datepicker" class="vs-input--label">Geboortedatum</label>
              <datepicker
                  placeholder="Selecteer een datum"
                  label="Geboortedatum"
                  v-model="createDeliverer.birth_date"
              ></datepicker>
            </template>
          </div>
          <div class="vx-col sm:w-1/2 w-full">
            <vs-input
                class="w-full"
                label="Salaris"
                :value="createDeliverer.salary"
                v-model="createDeliverer.salary"
            />
          </div>
        </div>
        <div class="vx-row w-full">
          <div class="vx-col w-1/2">
            <vs-select v-model="createDeliverer.area" class="w-full">
              <vs-select-item
                  v-for="(item) in areaOptions"
                  :key="item.name"
                  :value="item.name"
                  :text="item.name"
              />
            </vs-select>
          </div>
          <div class="vx-col w-1/2">
            <vs-select v-model="createDeliverer.drivers_licence" class="w-full pr-4">
              <vs-select-item
                  v-for="(item) in licenses"
                  :key="item.name"
                  :value="item.name"
                  :text="item.name"
              />
            </vs-select>
          </div>
        </div>

        <div class="vx-row mb-6">
          <div class="vx-col w-1/2">
            <ul class="switch-container">
              <li>
                <label>Kantoor</label>
                <vs-switch v-model="createDeliverer.office"/>
              </li>
            </ul>
          </div>
        </div>

        <vs-card>
          <div slot="header">
            <h5>Afbeelding</h5>
          </div>
          <div>
            <vs-upload @change="handleImageUpload" @on-delete="image = null"/>
          </div>
        </vs-card>

        <div class="vx-row">
          <div class="vx-col w-full">
            <vs-button class="mr-3 mb-2" @click="createDelivererModel(createDeliverer)">Opslaan</vs-button>
          </div>
        </div>
      </template>
    </vs-popup>
    <ht-hour-popup></ht-hour-popup>
  </div>
</template>

<script>
import analyticsData from "./analyticsData.js";
import Datepicker from "vuejs-datepicker";
import editHourPopup from "./EditHourPopup";
import vSelect from "vue-select";
import orders from "@/views/pages/Companies/single/orders";

export default {
  name: "ht-deliverer-popup",
  components: {
    Datepicker,
    "ht-hour-popup": editHourPopup
  },
  data() {
    return {
      analyticsData,
      showPopup: false,
      sendingNotification: false,
      device_token: null,
      showCreatePopup: false,
      deliverer: null,
      saved: false,
      current: {},
      notes: null,
      clothes: null,
      hours: [],
      orders: null,
      revenueComparisonLine: {},
      title: "",
      message: "",
      loading: false,
      areaOptions: [
        {
          lat: 51.8427533,
          lng: 4.3353594,
          name: "Spijkenisse",
          label: "Spijkenisse",
          zoom: 13,
          orders: [],
        },
        {
          lat: 51.9239947,
          lng: 4.3609799,
          name: "Schiedam",
          label: "Schiedam",
          zoom: 12.8,
          orders: [],
        },
        // {lat: 51.8247412, lng: 4.2563312, name: 'Zuidland', zoom: 14, orders: []},
        {
          lat: 51.8798463,
          lng: 4.5690483,
          name: "Ijsselmonde",
          label: "Ijsselmonde",
          zoom: 12,
          orders: [],
        },
        {
          lat: 52.019975,
          lng: 4.340991,
          name: "Delft",
          label: "Delft",
          zoom: 12,
          orders: [],
        },
      ],
      licenses: [
        {name: "AM"},
        {name: "AM+B"},
        {name: "B"},
        {name: "Geen rijbewijs"},
      ],
      image: null,
      color: "",

      createDeliverer: {
        firstname: "",
        insertion: "",
        lastname: "",
        phone_number: "",
        drivers_licence: "Geen rijbewijs",
        address: {
          city: "",
          street: "",
          postal_code: "",
          housenumber: 0
        },
        postal_code: "",
        housenumber: "",
        image: "",
        email: "",
        area: "Spijkenisse",
        office: 0,
        salary: null,
        birth_date: null,
      },
    };
  },
  mounted() {
    this.$events.listen('open-deliverer-modal', (deliverer) => {
      this.deliverer = deliverer;
      this.deliverer.office = deliverer.office;
      this.device_token = deliverer.device_token;
      this.current = JSON.stringify(this.deliverer);
      this.showPopup = true;
      this.title = '';
      this.message = '';
    });
    this.sendingNotification = false;
    this.loading = false;
    this.$events.listen("create-deliverer-modal", (event) => {
      this.showCreatePopup = true;
    });
    this.$events.listen('refresh-clothing', () => {
      this.getClothes();
    });
    window.addEventListener('keyup', (key) => {
      if (key.keyCode === 27) {
        this.showCreatePopup = false;
        this.showPopup = false;
      }
    });
  },

  computed: {
    isDeleted() {
      return this.deliverer.deleted_at !== undefined;
    },

    address() {
      return this.deliverer !== null ? this.deliverer.address.street + " " + this.deliverer.address.housenumber + ", " + this.deliverer.address.postal_code + " " + this.deliverer.address.city : this.createDeliverer.address.street + " " + this.createDeliverer.address.housenumber + ", " + this.createDeliverer.address.postal_code + " " + this.createDeliverer.address.city;
    },

    canSendNotification() {
      if (this.sendingNotification) {
        return this.sendingNotification;
      }
      return this.title === "" && this.message === "";
    },

    getNameTitle() {
      if (this.deliverer.firstname === null) {
        return "Bezorger Aanmaken";
      }
      return (
          this.deliverer.firstname +
          " " +
          (this.deliverer.insertion !== "null"
              ? this.deliverer.insertion + " "
              : "") +
          this.deliverer.lastname
      );
    },
    getAllHours: function () {
      return this.hours.filter(function (item) {
        return item.month !== null;
      });
    },
    getCreateTitle: function () {
      if (this.createDeliverer.firstname !== "") {
        return (
            this.createDeliverer.firstname +
            " " +
            (this.createDeliverer.insertion !== null
                ? this.createDeliverer.insertion + " "
                : "") +
            this.createDeliverer.lastname
        );
      } else {
        return "Bezorger Aanmaken";
      }
    },
  },

  watch: {
    "deliverer.address.housenumber": function () {
      this.getAddress(this.deliverer);
    },

    "createDeliverer.address.housenumber": function () {
      this.getAddress(this.createDeliverer);
    },
  },

  methods: {
    handleImageUpload: function (e, f) {
      this.image = f[0];
      this.deliverer.image = this.image;
    },
    createClothing() {
      this.$events.fire('open-clothing-model', this.deliverer);
      this.showPopup = false;
    },
    deleteClothing(clothe) {
      let data = {
        _method: 'DELETE',
        id: clothe.id,
      };
      this.$http
          .post("/v1/deliverer/clothes/delete", data, {
            headers: {
              Authorization:
                  "Bearer " + this.$util.getStaffToken(),
            },
          })
          .then(() => {
            this.getClothes();
            this.$util.notify('Gelukt', 'Data is verwijderd', this.$vs);
          })
          .catch((error) => {
            this.$util.logError(error, this.$vs);
          });
    },
    getTranslatedString(item) {
      return (
          "Ingeklokt om " +
          this.$moment(item.clocked_in_time).format("LTS") +
          " uitgeklokt om " +
          this.$moment(item.clocked_out_time).format("LTS")
      );
    },

    translateTime(time) {
      return this.$moment(time.created_at).calendar();
    },
    getDeliveries() {

    },
    editHour(hour) {
      this.$events.fire('open-deliverer-hour', hour);
    },
    getMonth(id) {
      let d = new Date();
      let month = new Array();
      month[1] = "January";
      month[2] = "February";
      month[3] = "March";
      month[4] = "April";
      month[5] = "May";
      month[6] = "June";
      month[7] = "July";
      month[8] = "August";
      month[9] = "September";
      month[10] = "October";
      month[11] = "November";
      month[12] = "December";
      return month[id];
    },
    deleteHour(hour) {
      let data = {
        id: hour.id,
      };
      this.$http
          .post("https://staffapi.hebtrek.nl/v1/deliverer/removehour", data, {
            headers: {
              Authorization:
                  "Bearer " + this.$util.getStaffToken(),
            },
          })
          .then((response) => {
            this.getHours();
            this.$vs.notify({
              title: "Gelukt!",
              text: "Data is verwijderd",
              color: "green",
              position: "top-center",
            });
          })
          .catch((error) => {
            this.$util.logError(error, this.$vs);
          });
    },
    resetDeviceToken(deliverer) {
      let data = {
        id: this.deliverer.id,
      };
      this.$http
          .post(
              "https://staffapi.hebtrek.nl/v1/deliverer/reset-device-token",
              data,
              {
                headers: {
                  Authorization:
                      "Bearer " + this.$util.getStaffToken(),
                },
              }
          )
          .then(() => {
            this.showPopup = false;
            this.$vs.notify({
              title: "Gelukt!",
              text: "Token van " + deliverer.firstname + " gereset!",
              color: "green",
              position: "top-center",
            });
          })
          .catch((error) => {
            this.$util.logError(error, this.$vs);
          });
    },

    createDelivererModel(deliverer) {
      let data = new FormData();
      data.append('_method', 'POST');
      data.append('id', deliverer.id);
      data.append('office', deliverer.office);
      data.append('area', deliverer.area);
      data.append('firstname', deliverer.firstname);
      data.append('insertion', deliverer.insertion);
      data.append('lastname', deliverer.lastname);
      data.append('postal_code', deliverer.address.postal_code);
      data.append('housenumber', deliverer.address.housenumber);
      data.append('city', deliverer.address.city);
      data.append('street', deliverer.address.street);
      data.append('birth_date', this.$moment(deliverer.birth_date).format());
      data.append('salary', deliverer.salary);
      data.append('phone_number', deliverer.phone_number);
      data.append('email', deliverer.email);
      data.append('drivers_licence', deliverer.drivers_licence);
      data.append('image', this.image);
      this.$http
          .post("https://staffapi.staging.hebtrek.nl/v1/deliverer/create", data, {
            headers: {
              Authorization:
                  "Bearer " + this.$util.getStaffToken(),
            },
          })
          .then(() => {
            this.showCreatePopup = false;
            this.$events.fire("update-deliverer-list");
            this.$util.notify('Gelukt!', 'Bezorger ' + deliverer.firstname + ' is aangemaakt', this.$vs);
          })
          .catch((error) => {
            this.$util.logError(error, this.$vs);
          });
    },
    resetDeliverer(deliverer) {
      let data = new FormData();
      data.append('_method', 'PUT');
      data.append('delivererId', deliverer.id);
      this.$http
          .post("/v1/deliverer/reset", data, {
            headers: {
              Authorization:
                  "Bearer " + this.$util.getStaffToken(),
            },
          })
          .then(() => {
            this.showPopup = false;
            this.$util.notify('Herstelt', deliverer.firstname + ' is weer in dienst', this.$vs);
          })
          .catch((error) => {
            this.$util.logError(error, this.$vs);
          });
    },


    fireDeliverer(deliverer) {
      let data = {
        _method: "DELETE",
        id: deliverer._id,
        reason: "Ontslagen op staande voet",
      };
      this.$http
          .post("https://staffapi.staging.hebtrek.nl/v1/deliverer/delete", data, {
            headers: {
              Authorization:
                  "Bearer " + this.$util.getStaffToken(),
            },
          })
          .then(() => {
            this.showPopup = false;
            this.$events.fire('refresh-deliverers');
            this.$util.notify('Ontslagen', deliverer.firstname + ' is verwijderd!', this.$vs);
          })
          .catch((error) => {
            this.$util.logError(error, this.$vs);
          });
    },

    getNotes() {
      this.notes = null;
      this.$http
          .get("/v1/deliverer/notes", {
            params: {
              id: this.deliverer.id,
            },
            headers: {
              Authorization:
                  "Bearer " + this.$util.getStaffToken(),
            },
          })
          .then((response) => {
            this.notes = response.data;
          })
          .catch((error) => {
            this.$util.logError(error, this.$vs);
          });
    },

    getJobs() {
      this.$http
          .get("https://api.staging.hebtrek.nl/deliverer/jobs", {
            headers: {
              Authorization:
                  "Bearer " + this.deliverer.api_token,
            },
          })
          .then((response) => {
            this.orders = response.data.jobs;
            console.log(this.orders);
          })
          .catch((error) => {
            this.$util.logError(error, this.$vs);
          });
    },

    getOrderTitle(delivery) {
      let id = new String(delivery.orderId);
      let string = id.substring(id.length - 4);
      return delivery.companyName + " #" + string;
    },

    getAddressString(delivery, area) {
      return "Bestelling naar " + delivery.customerAddress;
    },

    getClothes() {
      this.notes = null;
      this.$http
          .get("/v1/deliverer/clothes", {
            params: {
              id: this.deliverer.id,
            },
            headers: {
              Authorization:
                  "Bearer " + this.$util.getStaffToken(),
            },
          })
          .then((response) => {
            this.clothes = response.data;
          })
          .catch((error) => {
            this.$util.logError(error, this.$vs);
          });
    },

    getHours() {
      this.hours = null;
      this.$http
          .get("/v1/deliverer/hours", {
            params: {
              id: this.deliverer.id,
            },
            headers: {
              Authorization:
                  "Bearer " + this.$util.getStaffToken(),
            },
          })
          .then((response) => {
            this.hours = response.data;
          })
          .catch((error) => {
            this.$util.logError(error, this.$vs);
          });
    },

    getAddress(deliverer) {
      if (deliverer === null) {
        return;
      }
      if (deliverer.address.housenumber === "") {
        return;
      }
      console.log('ere');
      this.$http
          .get(
              "/v1/address?api_token=" +
              this.$util.getStaffToken(),
              {
                params: {
                  zipcode: deliverer.address.postal_code,
                  number: deliverer.address.housenumber,
                },
              }
          )
          .then((response) => {
            deliverer.address.housenumber = response.data.number;
            deliverer.address.postal_code = response.data.postcode;
            deliverer.address.street = response.data.street;
            deliverer.address.city = response.data.city;
          })
          .catch((error) => {
            this.$util.logError(error, this.$vs);
          });
    },
    clockOut(deliverer) {
      this.showPopup = false;
      this.$vs.notify({
        title: "Wat een strijder",
        text: "Je hebt " + deliverer.firstname + " uitgeklokt",
        color: "red",
        position: "top-center",
      });
    },

    sendNotification(deliverer, silent) {
      this.sendingNotification = true;
      let data = {
        title: this.title,
        _id: deliverer._id,
        content: this.message,
        sound: "default",
        screen: "dashboard"
      };
      this.$util.loading('#send-deliverer-notification', this.$vs);
      this.$http
          .post('https://api.hebtrek.com/v2/staff/driver/notification/send', data, {
            headers: {
              Authorization:
                  "Bearer " + this.$util.getStaffToken(),
            },
          })
          .then(() => {
            this.showPopup = false;
            this.sendingNotification = false;
            this.$vs.loading.close('#send-deliverer-notification > .con-vs-loading');
            if (!silent) {
              this.$util.notify('Gelukt', 'Bericht naar ' + deliverer.firstname + ' is verstuurd!', this.$vs);
            }
          })
          .catch((error) => {
            this.$util.logError(error, this.$vs);
            this.sendingNotification = false;
          });
    },

    sendSms(deliverer, silent) {
      this.$vs.loading({
        background: 'primary',
        color: '#fff',
        container: "#send-sms-button",
        scale: 0.45
      });
      let data = {
        title: this.title,
        deliverer_id: deliverer._id,
        message: this.message
      };
      this.$http
          .post('https://api.staging.hebtrek.nl/staff/text/send', data, {
            headers: {
              Authorization:
                  "Bearer " + this.$util.getStaffToken(),
            },
          })
          .then(() => {
            this.$vs.loading.close("#send-sms-button > .con-vs-loading");
            this.showPopup = false;
            if (!silent) {
              this.$vs.notify({
                title: "Gelukt!",
                text: "Bericht naar " + deliverer.firstname + " is verstuurd!",
                color: "green",
                position: "top-center",
              });
            }
          })
          .catch((error) => {
            this.$vs.loading.close("#send-sms-button > .con-vs-loading");
            this.$util.logError(error, this.$vs);
          });
    },
    saveDelivererModal(deliverer) {
      this.$util.loading('#save-deliverer-button', this.$vs);
      this.loading = true;
      let data = new FormData();
      data.append('_method', 'PUT');
      data.append('id', deliverer._id);
      data.append('office', deliverer.office);
      data.append('area', deliverer.area);
      data.append('firstname', deliverer.firstname);
      data.append('insertion', deliverer.insertion);
      data.append('lastname', deliverer.lastname);
      data.append('salary', deliverer.salary);
      data.append('postal_code', deliverer.address.postal_code);
      data.append('housenumber', deliverer.address.housenumber);
      data.append('city', deliverer.address.city);
      data.append('street', deliverer.address.street);
      data.append('birth_date', this.$moment(deliverer.birth_date).format());
      data.append('phone_number', deliverer.phone_number);
      data.append('email', deliverer.email);
      data.append('drivers_licence', deliverer.drivers_licence);
      data.append('image', this.image);
      data.append('device_token', this.device_token);
      data.append('color', deliverer.color);
      this.$http
          .post("https://staffapi.staging.hebtrek.nl/v1/deliverer/update", data, {
            headers: {
              Authorization:
                  "Bearer " + this.$util.getStaffToken(),
            },
          })
          .then(() => {
            this.saved = true;
            this.showPopup = false;
            this.disabled = false;
            this.$vs.loading.close("#save-deliverer-button > .con-vs-loading");
            this.$vs.notify({
              title: "Gelukt!",
              text: "Gegevens voor " + deliverer.firstname + " zijn opgeslagen!",
              color: "green",
              position: "top-center",
            });
            this.$events.fire('refresh-deliverers');
          })
          .catch((error) => {
            this.$vs.loading.close("#save-deliverer-button > .con-vs-loading");
            this.$util.logError(error, this.$vs);
          });
    },
  },
};
</script>

<style>
.vs-list {
  padding: 0;
}

.va-list-item {
  padding: 0;
  margin-left: -10px;
  margin-right: -10px;
}

.ht-image {
  width: auto;
}

.img-upload,
.con-input-upload {
  width: 100%;
  margin-left: 0px;
  margin-top: 0px;
}
</style>
